import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import App from './App';
import './styles/index.css';
import { useRoomStore } from './stores/roomStore';

if (import.meta.env.DEV) {
  // 개발 중 디버깅용: 브라우저 콘솔에서 방 상태 확인
  (window as unknown as { __roomStore: typeof useRoomStore }).__roomStore = useRoomStore;
}

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
